import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import loadPDFs from '../library/loadPDFs';

class PRSingleReportPane extends Component {
  componentDidMount() {
    setTimeout(this.scrollToDoc.bind(this, loadPDFs), 1);
    setTimeout(this.props.componentReady, 300);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location && this.props.allowWindowJump) {
      this.scrollToDoc();
    }
  }

  scrollToDoc(callback) {
    const activeDocSlug = `${this.props.match.params.orgSlug}-${this.props.match.params.docSlug}`;
    const doc = document.querySelector(`#${activeDocSlug}`);
    if (doc) {
      $('html, body').animate(
        { scrollTop: $(doc).offset().top - $('header')[0].offsetHeight },
        300,
      );
    }
    if (typeof callback === 'function') {
      callback();
    }
  }

  render() {
    const { reports, match } = this.props;
    const activeReportSlug = match.params.report_slug;
    const activeReport = reports.filter(x => x.slug === activeReportSlug)[0];
    // const activeDocSlug = match.params.docSlug;
    // const activeDoc = activeReport.reports.filter(x => x.slug === activeDocSlug)[0];
    return (
      <div className="pane" id="single-report-pane">
        {activeReport.download_all_pdf && 
          <a href={activeReport.download_all_pdf} download className={"download-all"}>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
              <g fill="none" fillRule="evenodd" stroke="#0091C8" transform="translate(1 1)">
                <rect width="46" height="46" rx="23"/>
                <path strokeLinejoin="round" d="M23,10.4875154 L23,20.5060967"/>
                <polygon points="16.033 20 22.848 29.144 29.967 20"/>
                <path strokeLinecap="square" d="M11.5 26.5L11.5 33.5710678M34.5 26.5L34.5 33.5710678M34.0710678 34L12.2178995 34"/>
              </g>
            </svg>
            Download All Materials
          </a>
        }
        {Object.keys(activeReport.reports).map(key =>
          activeReport.reports[key].children.map(x => (
            <section
              key={`${x.slug}`}
              id={`${activeReport.reports[key].slug}-${x.slug}`}
              data-nice-route={`${activeReport.reports[key].slug}/${x.slug}`}
            >
              <h2>{x.title}</h2>
              <div className="pdf-embed-wrapper">
                <div
                  className="padding"
                  style={{ paddingBottom: x.ratio }}
                  dangerouslySetInnerHTML={{ __html: x.embedCode }}
                />
              </div>
              {/* <div className="iframe-wrapper">
                  <div className="padding" />
                  <iframe
                    title={x.title}
                    frameBorder="0"
                    src={`http://view.officeapps.live.com/op/view.aspx?src=${encodeURI(x.url)}&embedded=true`}
                    scrolling="yes"
                  />
                </div> */}
            </section>
          )))}
      </div>
    );
  }
}

PRSingleReportPane.propTypes = {
  location: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ docSlug: PropTypes.string }) }).isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allowWindowJump: PropTypes.bool.isRequired,
};

export default PRSingleReportPane;
